import { render, staticRenderFns } from "./addItemType.vue?vue&type=template&id=86e4ad48&"
import script from "./addItemType.vue?vue&type=script&lang=js&"
export * from "./addItemType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86e4ad48')) {
      api.createRecord('86e4ad48', component.options)
    } else {
      api.reload('86e4ad48', component.options)
    }
    module.hot.accept("./addItemType.vue?vue&type=template&id=86e4ad48&", function () {
      api.rerender('86e4ad48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/itemListComp/addItemType.vue"
export default component.exports